import { useAtomValue } from "jotai";
import { useLocation } from "react-router-dom";
import { useSideNavigationLinks } from "@/hooks";
import { ROUTES } from "@/constants/routes";
import { navActiveOverrideAtom } from "@/stores/atoms/nav-active-override-atom";

export function useActiveNavHref(): string | null {
  const override = useAtomValue(navActiveOverrideAtom);
  const navigationLinks = useSideNavigationLinks();
  const { pathname } = useLocation();

  if (override) return override;

  const allHrefs = [...navigationLinks.map((l) => l.href), ROUTES.SETTINGS];
  return (
    allHrefs
      .filter((href) => pathname === href || pathname.startsWith(href + "/"))
      .sort((a, b) => b.length - a.length)[0] ?? null
  );
}
